import { Component, type ErrorInfo, type ReactNode } from 'react'
import { RotateCcw, TriangleAlert } from 'lucide-react'

export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }

  static getDerivedStateFromError(): { failed: true } {
    return { failed: true }
  }

  componentDidCatch(_error: Error, _info: ErrorInfo): void {
    // The verifier remains the source of operational telemetry. Do not send run data
    // or render exceptions to an unrelated product analytics service.
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children
    return (
      <main role="alert" className="grid min-h-dvh place-items-center px-6">
        <div className="flex max-w-md flex-col items-center gap-3 text-center">
          <TriangleAlert aria-hidden className="size-7 text-status-warn" />
          <h1 className="text-xl font-semibold tracking-tight">
            The run viewer hit an unexpected error
          </h1>
          <p className="text-sm text-muted-foreground">
            The test result has not been changed. Reload the viewer to fetch a fresh, validated
            projection from the verifier.
          </p>
          <button
            type="button"
            className="mt-2 inline-flex h-9 items-center gap-2 rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-none"
            onClick={() => window.location.reload()}
          >
            <RotateCcw aria-hidden className="size-3.5" />
            Reload viewer
          </button>
        </div>
      </main>
    )
  }
}
